<template>
  <div class="solution-wrap">
    <div class="banner-wrap">
      <img class="solution-banner" src="../../assets/images/solution_banner.jpg" alt="">
    </div>
    <!-- 三个课堂 -->
    <div class="three-class">
      <img class="three-class-img" src="../../assets/images/solution/solution.png" alt="">
      <div class="three-class-text">
        <p class="title">基于“三个课堂”的<br/>区域教育优质均衡解决方案</p>
        <p class="content">“基于‘三个课堂’的区域教育优质均衡解决方案”是以智慧教育云平台为依托，以优质教育共建共享为基础，以实现教育均衡、达成智慧教学、促进教师发展为目标，以模块化多层级灵活部署为特色，以“交付即开始”的运维服务为保障的成熟解决方案；是助力市(州)、区(县、旗)实现区域教育优质均衡及高质量发展的综合解决方案。</p>
      </div>
    </div>
    <!-- 解决方案 -->
    <div class="solution-content">
      <div class="solution-item" v-for="(item, index) in list" :key="index">
        <img class="solution-item-img" :src="item.imgUrl" alt="">
        <div class="solution-item-text" :class="index==4?'small-padding':''">
          <p class="solution-item-title" v-html="item.title" :style="'color:' + item.color"></p>
          <p class="solution-item-content">{{item.content}}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      list: [{
        imgUrl: require('../../assets/images/solution/solution_1.png'),
        title: '数据驱动下的智慧课堂精准教学',
        color: '#0463C0',
        content: '“爱学派”云课堂是在“平台、课堂模型和教研服务”支持下，通过构建个性化、智能化、数字化的学习环境，变革教与学的方式方法，将信息技术深度融合于课堂教学中，实现学习内容精髓化、学习过程智能化、评价反馈及时化、教学过程数据化的智慧课堂解决方案。'
      }, {
        imgUrl: require('../../assets/images/solution/solution_2.png'),
        title: '基于“专递课堂”的教育均衡解决方案',
        color: '#0CA1C9',
        content: '“专递课堂”针对薄弱学校和教学点缺少师资，开不足开不好国家规定课程的问题，通过网络专门开课或者同步上课，将优质教育同步到教育薄弱地区，使课程“开不齐，开不足、开不好”的问题得到根本改变，促进教育公平和均衡发展。该解决方案具体以“同步课堂、双师课堂、空中课堂”等形式来体现。'
      }, {
        imgUrl: require('../../assets/images/solution/solution_3.png'),
        title: '“双减”背景下的智慧作业解决方案',
        color: '#4BA65F',
        content: '“爱学”智慧作业是响应国家政策，立足提升教学质量，根据学校真实作业场景，通过平台布置分层、弹性和个性化作业，将日常作业流程信息化、统计分析数字化、反馈指导及时化，为教师提供教学策略改进的依据，充分发挥作业的巩固、测试、学情分析的作用，实现减负增效。'
      }, {
        imgUrl: require('../../assets/images/solution/solution_4.png'),
        title: '基于“名师课堂”的教研共同体应用方案',
        color: '#FAC72E',
        content: '依托20多年的教育积淀和实践经验，搭建智能网络教研平台，利用大数据技术将教师教学行为进行收集与分析，再结合AI课例分析等先进技术手段，促进区域教师研修共同体的形成和持续发展，建设数据驱动的线上线下相结合的教研新生态，创建教师专业发展新路径，是提升教师综合素质的解决方案。'
      }, {
        imgUrl: require('../../assets/images/solution/solution_5.png'),
        title: '基于“名校网络课堂”的优质教育共建共享方案',
        color: '#E77325',
        content: '结合教育信息化推广实施的经验和区域教育发展的现状，创新优质教育供给形式，构建“以用促建、共建共享”优质教育新生态的解决方案。旨在激活当地教育共建共享，实现“名校网络课堂”建设，缩小区域（城乡、校级）教育质量差距，助力教育优质均衡发展。'
      }, {
        imgUrl: require('../../assets/images/solution/solution_6.png'),
        title: '基于考试数据的教学评价及改进方案',
        color: '#B22B2E',
        content: '利用现代信息技术手段，通过对考试测评数据进行专业化分析，获取可参考信息，发现可解决问题，再经过专业教研员、骨干教师的教研支持和本地教师的教研活动，持续改进教与学方式方法的教学改进方案；是指向学生学业质量发展和教师教学水平提升的、可落地实施的教学改进方案；是“工具+服务+教研”三位一体的教学改进方案。'
      }]
    }
  }
}
</script>
<style lang="scss" scoped>
.solution-wrap {
  width: 100%;
  .banner-wrap {
    width: 100%;
    position: relative;
    .solution-banner {
      width: 100%;
      // height: 568px;
      display: block;
    }
  }
  .three-class {
    display: flex;
    width: 1170px;
    height: 406px;
    background: #FFFFFF;
    box-shadow: 1px 13px 47px 2px rgba(61, 61, 61, 0.25);
    margin: 0 auto;
    margin-top: 142px;
    .three-class-img {
      width: 500px;
      height: 406px;
      flex-shrink: 0;
    }
    .three-class-text {
      padding: 42px 55px 0;
      color: #3E3A39;
      font-weight: 400;
      .title {
        font-size: 33px;
        line-height: 44px;
      }
      .content {
        font-size: 22px;
        color: #595757;
        line-height: 36px;
        margin-top: 16px;
      }
    }
  }
  .solution-content {
    margin-bottom: 226px;
    background: url('../../assets/images/bg.png') no-repeat;
    background-size: 100% auto;
    background-position: 0 603px;
  }
  .solution-item {
    display: flex;
    width: 1170px;
    height: 348px;
    margin: 0 auto;
    margin-top: 90px;
    background: #FFFFFF;
    box-shadow: 1px 13px 47px 2px rgba(61, 61, 61, 0.25);
    padding: 0 62px;
    .solution-item-img {
      width: 284px;
      height: 398px;
      margin: -26px 48px 0 0;
      flex-shrink: 0;
    }
    .solution-item-text {
      padding-top: 65px;
    }
    .small-padding {
      padding-top: 40px;
    }
    .solution-item-title {
      font-size: 33px;
      font-weight: 400;
      line-height: 33px;
      margin-bottom: 24px;
    }
    .solution-item-content {
      font-size: 22px;
      font-weight: 400;
      color: #595757;
      line-height: 36px;
      text-align: justify;
      text-align-last: left;
    }
  }
}
</style>